import { render, staticRenderFns } from "./InitialAnimation.vue?vue&type=template&id=27af0a71&scoped=true"
import script from "./InitialAnimation.vue?vue&type=script&lang=js"
export * from "./InitialAnimation.vue?vue&type=script&lang=js"
import style0 from "./InitialAnimation.vue?vue&type=style&index=0&id=27af0a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af0a71",
  null
  
)

export default component.exports